import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import Button from 'components/Button/Button';
import Braintree from 'components/Braintree/Braintree';
import UserStore from 'stores/User';
import AlertStore from 'stores/Alert';
import goxApi from 'api/gox-api';
import styles from './AddFunds.module.scss';

const AddFunds = observer(() => {

  const navigate = useNavigate();
  const braintree = useRef();
  const [ processing, setProcessing ] = useState(false);

  useEffect(() => {
    UserStore.fetch();
  }, []);

  function price(cents) {
    return `$${((cents ?? 0) / 100).toFixed(2)}`;
  }

  async function buy(plan) {
    if (processing) {
      return;
    }
    try {
      setProcessing(true);
      const { success, message } = await UserStore.hasCard();
      if (!success) {
        if (message) {
          AlertStore.add(message);
        }
        await braintree.current.init();
      }
      await goxApi.addFunds(plan.id);
      await UserStore.fetch();
      AlertStore.add(`Balance refilled: +${price(plan.amount)}`);
    } catch (err) {
      AlertStore.add(err.message);
    } finally {
      setProcessing(false);
    }
  }

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Add Funds</h1>

      <div className={styles.balance}>
        <div className={styles.amount}>{price(UserStore.mainBalance + UserStore.bonusBalance)}</div>
        <div className={styles.label}>
          Your balance
          {UserStore.bonusBalance > 0 && ` (includes ${price(UserStore.bonusBalance)} bonus)`}
        </div>
      </div>

      <div className={styles.plans}>
        {UserStore.refillPlans.map((plan) => (
          <button
            type="button"
            key={plan.id}
            className={styles.plan}
            disabled={processing}
            onClick={() => buy(plan)}
          >
            <span className={styles.planAmount}>{price(plan.amount)}</span>
            {plan.bonus_percent > 0 &&
              <span className={styles.planBonus}>+{plan.bonus_percent}% bonus</span>
            }
          </button>
        ))}
      </div>

      <div className={styles.note}>
        Charged to your default payment method.
      </div>

      <Button grey className={styles.back} onClick={() => navigate(-1)}>
        Back
      </Button>

      <Braintree ref={braintree} />
    </div>
  );
});

export default AddFunds;
